import { render, staticRenderFns } from "./PricingStrategy.vue?vue&type=template&id=4be18336&scoped=true&"
import script from "./PricingStrategy.vue?vue&type=script&lang=js&"
export * from "./PricingStrategy.vue?vue&type=script&lang=js&"
import style0 from "./PricingStrategy.vue?vue&type=style&index=0&id=4be18336&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be18336",
  null
  
)

export default component.exports